import React, { useEffect, useState } from 'react';

const OtpInputBox = ({ length, clearOTP, onOtpChange, disabled }) => {
    const [otp, setOtp] = useState(new Array(length).fill(''));
    const [disable, setDisable] = useState(false);

    useEffect(() => {
        document.getElementById(`otp-input-${0}`).focus();
        if (clearOTP) {
            setOtp(new Array(length).fill(''));
        }
        if (disabled) {
            setDisable(true);
        }
    }, [clearOTP, length]);

    const handleChange = (e, index) => {
        const newOtp = [...otp];
        newOtp[index] = e.target.value.replace(/\D/g, '');
        setOtp(newOtp);
        // Move to the next input box automatically

        if (e.target.value !== '' && index < length - 1 && /^\d+$/.test(e.target.value)) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }
        onOtpChange(newOtp);

    };

    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && index > 0 && !otp[index]) {
            const newOtp = [...otp];
            newOtp[index - 1] = '';
            setOtp(newOtp);
            document.getElementById(`otp-input-${index - 1}`).focus();
            onOtpChange(newOtp);

        }
    };

    return (
        <>
            <div>
                {otp.map((digit, index) => (
                    <input className='form-control'
                        key={index}
                        id={`otp-input-${index}`}
                        type="text"
                        maxLength={1}
                        value={digit}
                        onChange={(e) => handleChange(e, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        inputMode="numeric"
                        disabled={disable}
                    />
                ))}
            </div>
        </>
    );
};

export default OtpInputBox;